exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-tooltip__popper[data-v-02fc527c] {\n  max-width: 45vw !important;\n}\n", ""]);

// exports
